/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { templatesCreate } from "../funcs/templatesCreate.js";
import { templatesDelete } from "../funcs/templatesDelete.js";
import { templatesGet } from "../funcs/templatesGet.js";
import { templatesList } from "../funcs/templatesList.js";
import { templatesRender } from "../funcs/templatesRender.js";
import { templatesRenderByID } from "../funcs/templatesRenderByID.js";
import { templatesUpdate } from "../funcs/templatesUpdate.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { CreatePromptTemplateResult } from "../models/components/createprompttemplateresult.js";
import { GetPromptTemplateResult } from "../models/components/getprompttemplateresult.js";
import { ListPromptTemplatesResult } from "../models/components/listprompttemplatesresult.js";
import { RenderTemplateResult } from "../models/components/rendertemplateresult.js";
import { UpdatePromptTemplateResult } from "../models/components/updateprompttemplateresult.js";
import {
  CreateTemplateRequest,
  CreateTemplateSecurity,
} from "../models/operations/createtemplate.js";
import {
  DeleteTemplateRequest,
  DeleteTemplateSecurity,
} from "../models/operations/deletetemplate.js";
import {
  GetTemplateRequest,
  GetTemplateSecurity,
} from "../models/operations/gettemplate.js";
import {
  ListTemplatesRequest,
  ListTemplatesSecurity,
} from "../models/operations/listtemplates.js";
import {
  RenderTemplateRequest,
  RenderTemplateSecurity,
} from "../models/operations/rendertemplate.js";
import {
  RenderTemplateByIDRequest,
  RenderTemplateByIDSecurity,
} from "../models/operations/rendertemplatebyid.js";
import {
  UpdateTemplateRequest,
  UpdateTemplateSecurity,
} from "../models/operations/updatetemplate.js";
import { unwrapAsync } from "../types/fp.js";

export class Templates extends ClientSDK {
  /**
   * createTemplate templates
   *
   * @remarks
   * Create a new prompt template.
   */
  async create(
    request: CreateTemplateRequest,
    security?: CreateTemplateSecurity | undefined,
    options?: RequestOptions,
  ): Promise<CreatePromptTemplateResult> {
    return unwrapAsync(templatesCreate(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * deleteTemplate templates
   *
   * @remarks
   * Delete prompt template by its ID or name.
   */
  async delete(
    request?: DeleteTemplateRequest | undefined,
    security?: DeleteTemplateSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(templatesDelete(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getTemplate templates
   *
   * @remarks
   * Get prompt template by its ID or name.
   */
  async get(
    request?: GetTemplateRequest | undefined,
    security?: GetTemplateSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetPromptTemplateResult> {
    return unwrapAsync(templatesGet(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listTemplates templates
   *
   * @remarks
   * List available prompt template.
   */
  async list(
    request?: ListTemplatesRequest | undefined,
    security?: ListTemplatesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListPromptTemplatesResult> {
    return unwrapAsync(templatesList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * renderTemplateByID templates
   *
   * @remarks
   * Render a prompt template by ID with provided input data.
   */
  async renderByID(
    request: RenderTemplateByIDRequest,
    security?: RenderTemplateByIDSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RenderTemplateResult> {
    return unwrapAsync(templatesRenderByID(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * renderTemplate templates
   *
   * @remarks
   * Render a prompt template directly with all template fields provided.
   */
  async render(
    request: RenderTemplateRequest,
    security?: RenderTemplateSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RenderTemplateResult> {
    return unwrapAsync(templatesRender(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateTemplate templates
   *
   * @remarks
   * Update a prompt template.
   */
  async update(
    request: UpdateTemplateRequest,
    security?: UpdateTemplateSecurity | undefined,
    options?: RequestOptions,
  ): Promise<UpdatePromptTemplateResult> {
    return unwrapAsync(templatesUpdate(
      this,
      request,
      security,
      options,
    ));
  }
}
